import { VendorStatisticsRequest } from './vendor.statistics.request';

export class SendVendorStatsEmailRequest {
    Search: VendorStatisticsRequest;
    Email: string;
}
